export default "__VITE_ASSET__CLfM6jyi__"